export default __webpack_public_path__ + "media/zurb/img/services/services/ecommerce-site-img-afca22391d9698dd33bc5f6579dbe0a6.png";